import * as React from "react";

const Facebook: React.FC = () => {
    return <svg width="11px" height="24px" viewBox="0 0 11 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-869.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(775.000000, 175.000000)" id="UI-Icon/facebook">
                    <path d="M21.1381699,31.0562745 L21.1381699,19.5126797 L24.9472549,19.5126797 L25.549085,15.6872549 L21.1381699,15.6872549 L21.1381699,13.769085 C21.1381699,12.770915 21.4654248,11.8181699 22.8981699,11.8181699 L25.7617647,11.8181699 L25.7617647,8 L21.6963399,8 C18.2781699,8 17.3454248,10.2508497 17.3454248,13.370915 L17.3454248,15.6854902 L15,15.6854902 L15,19.5126797 L17.3454248,19.5126797 L17.3454248,31.0562745 L21.1381699,31.0562745 L21.1381699,31.0562745 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Facebook);
